<template lang="pug">
    .modal-overlay(v-if='show' @click.self='closeModal')
        .modal-content
            span(:style='"color: green; font-size: 18px; font-weight: bold;"') {{titulo}}

            .linha
                .coluna
                    span(:style='"color: black; font-size: 14px; font-weight: bold;"') Gerente Operacional:
                    span(:style='"font-size: 14px; margin-left: 6px;"') {{ document && document.nomeUsuario ? document.nomeUsuario : 'Nome não disponível' }}

            .linha
                .accordion-header(@click="toggleAccordion")
                    span Processos Vinculados ao Gerente
                    .icon
                        i.fas.fa-arrow-down(v-if="!isAccordionOpen")
                        i.fas.fa-arrow-up(v-if="isAccordionOpen")
                .container
                    .coluna
                        .accordion-body(v-show="isAccordionOpen")
                            .linha
                                .coluna
                                    filter-basic-component(
                                        @filtro:pesquisar='pesquisar({nome: $event, pagina: 1, quantidadePagina: 10})',
                                    )
                            .linha
                                .coluna
                                    grid-table-component(
                                        :headers="headers"
                                        :data="paginatedProcessos"
                                        :is-paginated="true"
                                        :is-loading="isLoading"
                                        :pagination="setPagination()"
                                        @table:page-changed="checkPaginationChange($event)"
                                        :enableMultiSelect="acao !== 'visualizar'"
                                        :selectedItemsGlobal="processosSelecionados"
                                        @selection:changed="onProcessosSelecionados"
                                    )
                                        template(v-slot:processo="{ item }")
                                            span {{ item.codigoImovel }}

                                        template(v-slot:condicao="{ item }")
                                            span {{ item.condicao.nomeCondicao || '' }}

            .linha(v-if="acao !== 'visualizar'")
                .accordion-header(@click="toggleAccordion")
                    span Processo(s) selecionado(s) para Migração
                    .icon
                        i.fas.fa-arrow-down(v-if="!isAccordionOpen")
                        i.fas.fa-arrow-up(v-if="isAccordionOpen")
                .container
                    .coluna
                        .accordion-body(v-show="isAccordionOpen")
                            div(v-if="processosSelecionados.length > 0")
                                ul
                                    li(v-for="processo in processosSelecionados" :key="processo.id") {{ processo.codigoImovel }}
                            div(v-else)
                                p Sem processos selecionados

            .linha
                .coluna
                    .footer
                        select-filter-component(
                            v-if="acao !== 'visualizar'"
                            :list="gerentesNomes"
                            label="nome"
                            fieldLabel="Gerente Operacional"
                            placeholder="Selecione o GO que deseja vincular"
                            :filterable="true"
                            @change="selecionarGO"
                        )

                        .linha(:style='"display: flex; justify-content: space-between;"')
                            button(
                                class="button-custom--btCancelar",
                                @click="closeModal"
                            )
                                .button-label(v-if="acao === 'visualizar'") Fechar
                                .button-label(v-else) Fechar

                            button(
                                v-if="acao !== 'visualizar'",
                                class="button-custom--btConfirmar",
                                :style='"button-background-color: green"'
                                @click="confirmarMigracao"
                            )
                                .button-label Confirmar
</template>



<script>
import { listarPorGerenteOperacional, alterarGerenteOperacionalProcesso } from '@/services/processo.service.js';
import { listarGerentesDiponiveisParaMigracao } from '@/services/usuario.service.js';
import FilterBasicComponent from '@/components/standard/FilterBasicComponent.vue'
import { ListaCondicoes } from '@/enums/processo.enum';
import { MessageBox } from 'element-ui';

export default {
    name: 'VisualizarProcessosGOModal',
    components: {
        FilterBasicComponent,
    },
    props: {
        titulo: {
            type: String,
            default: () => 'Migrar Processos',
        },
        data: {
            type: Array,
            default: () => [],
        },
        show: {
            type: Boolean,
            default: false,
        },
        document : {
            type: Object,
            default: () => {},
        },
        acao: {
            type: String,
            default: 'visualizar',
        },
        codigoImovel: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            migracaoFeita: false,
            gerentesDisponiveis: [],
            paginatedProcessos: [],
            gerentesNomes: [],
            isAccordionOpen: false,
            novoGOId: undefined,
            headers: [
                { text: 'Processo', field: 'processo' },
                { text: 'Condição', field: 'condicao' },
            ],
            processos: [],
            processosOriginais: [],
            processosSelecionados: [],
            isLoading: false,
            paginacao: {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
            },
        };
    },
    watch: {
        show(newVal) {
            if (newVal)
                this.carregarProcessosPorGerente();
        },
        document: {
            immediate: true, // Executa na primeira vez
            handler(newDocument) {
                if (this.show && newDocument && newDocument.idUsuario) {
                    this.carregarProcessosPorGerente();
                    if (this.acao !== 'visualizar')
                        this.carregarGerentesDisponiveis();

                }
            },
        },
        data() {
            this.all = false;
            this.selectedItems = [];
        }
    },

    methods: {
        async carregarGerentesDisponiveis() {
            if (!this.document || !this.document.idUsuario) {
                this.showToastError('ID do Gerente Operacional não fornecido.');
                return;
            }

            try {
                const gerentesDisponiveis = await listarGerentesDiponiveisParaMigracao(this.document.idUsuario);

                // Verifique se os dados contêm o campo esperado
                this.gerentesNomes = gerentesDisponiveis.map((gerente) => ({
                    ...gerente,
                    nome: gerente.pessoa?.nomeRazaoSocial || 'Nome não disponível',
                }));
            } catch (error) {
                this.showToastError('Erro ao carregar gerentes disponíveis');
            }
        },


        onProcessosSelecionados({ selectedItems, all }) {
            const idsPaginaAtual = new Set(this.paginatedProcessos.map(p => p.id));

            // remove tudo que pertence à página atual
            this.processosSelecionados = this.processosSelecionados.filter(
                processo => !idsPaginaAtual.has(processo.id)
            );

            // adiciona os selecionados da página atual
            for (const item of selectedItems) {
                if (!this.processosSelecionados.some(p => p.id === item.id)) {
                    this.processosSelecionados.push(item);
                }
            }
        },

        showToast(mensagem, tipo) {
            this.$toast({
                showClose: true,
                message: mensagem,
                type: tipo
            });
        },

        showToastSucesso(mensagem) {
            this.showToast(mensagem, 'success');
        },

        showToastError(mensagem) {
            this.showToast(mensagem, 'error');
        },

        async confirmarMigracao() {
            
            if (!this.document || !this.document.idUsuario) {
                this.showToastError('ID do Gerente Operacional não fornecido.');
                return;
            }

            const quantidadeProcessos = this.processosSelecionados.length;

            if (!quantidadeProcessos) {
                this.showToastError('Nenhum processo selecionado.');
                return;
            }

            if (!this.novoGOId) {
                this.showToastError('Nenhum novo Gerente Operacional selecionado.');
                return;
            }

            if (this.novoGOId === this.document.idUsuario) {
                this.showToastError('A migração deve ser feita entre Gerentes Operacionais distintos.');
                return;
            }

            const novoGO = this.gerentesNomes.find(g => g.id === this.novoGOId);
            const novoGONome = novoGO ? novoGO.nome : 'N/A';

            const mensagemConfirmacao =
                `<strong>ATENÇÃO:</strong> Você está prestes a migrar <strong>${quantidadeProcessos} processo(s)</strong> do Gerente Operacional "<strong>${this.document.nomeUsuario}</strong>" para "<strong>${novoGONome}</strong>".<br><br>` +
                `Esta ação <strong>não pode ser desfeita</strong> e será registrada no histórico do sistema.<br><br>` +
                `Deseja realmente continuar?`;

            try {
                await MessageBox.confirm(
                    mensagemConfirmacao,
                    'Confirmação de Migração de Processos',
                    {
                        confirmButtonText: 'Sim, Migrar',
                        cancelButtonText: 'Não, Cancelar',
                        type: 'warning',
                        dangerouslyUseHTMLString: true
                    }
                );

            } catch (e) {
                return;
            }

            // Verifica se algum processo selecionado possui uma das condições proibidas
            const condicoesProibidas = [
                'EM_REANALISE',
                'AGUARDANDO_ASSINATURA',
                'TERMO_COMPROMISSO_ASSINADO',
                'AGUARDANDO_ATENDIMENTO_PENDENCIA'
            ];

            const processoInvalido = this.processosSelecionados.find((processo) =>
                condicoesProibidas.includes(processo.condicao.idCondicao)
            );

            if (processoInvalido) {
                this.showToastError(
                    `Migração não permitida. Processo ${processoInvalido.codigoImovel} não pode ser migrado devido à condição impeditiva: "${processoInvalido.condicao.nomeCondicao}".`
                );

                return;
            }

            const idsProcessos = this.processosSelecionados.map((item) => item.id).join(',');

            if (!idsProcessos) {
                this.showToastError('Nenhum processo selecionado.');
                return;
            }

            try {

                await alterarGerenteOperacionalProcesso(
                    this.document.idUsuario,
                    this.novoGOId,
                    idsProcessos
                );

                this.$emit('update');

                this.showToastSucesso('Processo(s) migrados com sucesso.');

                // Remove os processos migrados da tabela
                this.processos = this.processos.filter(
                    (processo) => !this.processosSelecionados.some((selecionado) => selecionado.id === processo.id)
                );

                // Limpa os processos selecionados após a migração
                this.processosSelecionados = [];
            } catch (error) {
                this.showToastError('Erro ao migrar processos: ' + error);
            }
        },

        async checkPaginationChange(page) {
            const currentPage = typeof page === "object" ? page.page : page; // Garante que seja um número
            this.paginacao.pagina = currentPage;
            this.atualizarPaginacao();
        },

        atualizarPaginacao() {
            // Calcula os índices para a paginação
            const startIndex = (this.paginacao.pagina - 1) * this.paginacao.quantidadePagina;
            const endIndex = startIndex + this.paginacao.quantidadePagina;

            // Atualiza o array paginado e adiciona o nome da condição
            this.paginatedProcessos = this.processos.slice(startIndex, endIndex).map((item) => {
                const idCondicao = item.condicao.idCondicao;

                // Busca o valor correspondente no ListaCondicoes
                let encontrado = false;

                Object.values(ListaCondicoes).forEach((lista) => {
                    const condicaoEncontrada = lista.find((condicao) => condicao.id === idCondicao);
                    if (condicaoEncontrada) {
                        item.condicao.nomeCondicao = condicaoEncontrada.nome;
                        encontrado = true;
                    }
                });

                if (!encontrado) {
                    this.showToastError(`Condição não encontrada para idCondicao: ${idCondicao}`);
                }

                return item;
            });

            // Atualiza os dados de paginação
            this.paginacao.total = this.processos.length; // Total de processos
            this.paginacao.numeroPaginas = Math.ceil(this.paginacao.total / this.paginacao.quantidadePagina); // Número total de páginas
        },



        async carregarProcessosPorGerente() {
            if (!this.document || !this.document.idUsuario) {
                this.showToastError('ID do Gerente Operacional não fornecido.');
                return;
            }

            try {
                this.isLoading = true;

                const response = await listarPorGerenteOperacional(
                    this.document.idUsuario,
                    this.codigoImovel // pode ser null
                );

                this.processos = response.pageItems;
                this.processosOriginais = [...response.pageItems];

                this.paginacao.total = response.totalResults;
                this.paginacao.numeroPaginas = Math.ceil(
                    response.totalResults / this.paginacao.quantidadePagina
                );

                this.isAccordionOpen = true;
                this.atualizarPaginacao();

            } catch (error) {
                this.showToastError('Erro ao carregar processos: ' + error.message);
            } finally {
                this.isLoading = false;
            }
        },


        async listarGerentesDiponiveisParaMigracao() {
            if (!this.document || !this.document.idUsuario) {
                this.showToastError('ID do Gerente Operacional não fornecido.');
                return;
            }

            try {
                this.isLoading = true;
                const response = await listarGerentesDiponiveisParaMigracao(this.document.idUsuario);
                this.processos = response.data.pageItems;
                this.paginacao.total = response.data.totalResults;
                this.paginacao.numeroPaginas = Math.ceil(response.totalResults / this.paginacao.quantidadePagina);
                this.isAccordionOpen = true;
            } catch (error) {
                this.showToastError('Error ao listar gerentes disponiveis para migração.');
            } finally {
                this.isLoading = false;
            }
        },

        toggleAccordion() {
            this.isAccordionOpen = !this.isAccordionOpen;
        },

        closeModal() {
            this.$emit('close');
        },

        selecionarGO(idGO) {
            this.novoGOId = idGO;
        },

        setPagination() {
            return {
                page: this.paginacao.pagina,
                totalPages: this.paginacao.numeroPaginas,
                itemsPerPage: this.paginacao.quantidadePagina,
                totalItems: this.paginacao.total,
                order: 'ASC',
            };
        },

        pesquisar(filtro) {
            if (filtro && filtro.nome && filtro.nome.trim() !== '') {
                const filtroLimpo = filtro.nome.trim().replace(/\./g, '').toLowerCase();
                
                const processosFiltrados = this.processosOriginais.filter(processo => {
                    const codigoImovelLimpo = processo.codigoImovel.replace(/\./g, '').toLowerCase();
                    const nomeCondicao = processo.condicao?.nomeCondicao?.toLowerCase() || '';

                    return (
                        codigoImovelLimpo.includes(filtroLimpo) ||
                        nomeCondicao.includes(filtroLimpo)
                    );
                });
                
                this.processos = processosFiltrados;
                
                this.paginacao.pagina = 1;
                this.atualizarPaginacao();
            } else {
                this.processos = [...this.processosOriginais];
                this.paginacao.pagina = 1;
                this.atualizarPaginacao();
            }
        },
    },
};
</script>


<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 40vw; /* 40% da largura da viewport */
    min-height: 30vh; /* 80% da altura da viewport */
    max-width: none; /* Remove a restrição de largura máxima */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    overflow: auto; /* Para permitir rolagem caso o conteúdo exceda */
}


h3 {
    margin-top: 0;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
}

label {
    display: block;
    margin-bottom: 5px;
}

input[type='text'] {
    width: 100%;
    height: 30px;
    padding: 0px;
    border: 1px solid #ccc;
    border-radius: 4px;
}


button {
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}


.accordion-header {
    display: flex;
    justify-content: space-between;
    background-color: #e0dfdf;
    font-style: normal;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    width: 100%;
    font-size: 14px;
    color: #5f5f5f;
    cursor: pointer;
    padding: 12px 12px;
    font-weight: bold;
}
.accordion-body {

    overflow: hidden;
    transition: height 0.3s ease;
}

.button-custom--btConfirmar {
    height: 40px;
    background-color: var(--button-background-color, var(--primary-green));
    color: white;
}

.container {
    display: flex;
    width: 100%;
    margin-top: -5px;
    padding-left: 12px;
    padding-right: 12px;
    border: 1px solid #e0dfdf;
    border-radius: 6px;
}

.footer {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.button-custom--btCancelar {
    height: 40px;
    background-color: red;
    color: white;
}


</style>
